import NoBreakCommand from "./NoBreakCommand";
import NoBreakEditing from "./NoBreakEditing";
import NoBreakUI from "./NoBreakUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class NoBreak extends Plugin {
  init() {
    const editor = this.editor;
  }

  static get pluginName() {
    return "NoBreak";
  }

  static get requires() {
    return [NoBreakCommand, NoBreakUI, NoBreakEditing];
  }
}
